import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { NewNicaFormComponent } from '../../../../components/nica-form/new-nica-form.component';
import { alert, confirm } from 'devextreme/ui/dialog';
import { ComponentService } from '../../../../services/component.service';
import { IModelloStampa, ModelliStampaService } from '../../../../services/modelli-stampa.service';
import { Apiservice } from '../../../../services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';

export interface nota {
  dataRegistrazione: Date
  protocollo: string
  nota: string | null
  countMovimentiConsolidati?: number;
  dataRegistrazionePrimoMovimentoDaConsolidare?: Date | null
}

@Component({
  selector: 'app-popup-stampa-registri',
  templateUrl: './popup-stampa-registri.component.html',
  styleUrls: ['./popup-stampa-registri.component.css']
})
export class PopupStampaRegistriComponent implements OnInit {
  moment = require('moment');
  // @ViewChild('formPopupStampaRegistri', { static: true }) formPopupStampaRegistri: NewNicaFormComponent;
  @Input() reletedData: { [key: string]: any } = {};
  @Input() guid: any
  @Input() buttonCustomsBottomToolbar = [
    {
      id: 'genera',
      text: 'Genera',
      icon: 'dx-icon-export',
      disabled: false,
      visible: true,
      name: 'genera',
      location: 'after',
      widget: 'button'
    }
  ];
  radioData = [
    {
      value: 'stampaEsportazione',
      descrizione: 'Stampa Uso Interno',
    },
    {
      value: 'esportazioneDefinitiva',
      descrizione: 'Esportazione Definitiva Registro',
    },
    {
      value: 'stoccaggio',
      descrizione: 'Stoccaggio Istantaneo',
    },
  ]
  formPopupStampaRegistri = {
    azione: null,
    daData: undefined,
    aData: undefined,
  }
  minAllaData = undefined
  protected modelloRegistroRentri: IModelloStampa | null = null
  protected note: nota | null = {
    dataRegistrazione: undefined,
    protocollo: '000000',
    countMovimentiConsolidati: 0,
    nota: 'Non esistono movimenti da inviare sul registro cronologico',
    dataRegistrazionePrimoMovimentoDaConsolidare: null
  }

  constructor(private componentService: ComponentService, private modelliStampaService: ModelliStampaService, private apiService: Apiservice, private spinner: NgxSpinnerService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    if (!this.reletedData) {
      alert('Errore dati non disponibili', 'Attenzione')
      return
    }
    this.reload().then(() => {
      // if (this.note) this.formPopupStampaRegistri.daData = this.moment(this.note.dataRegistrazione).add(1, 'days')
    })
  }

  emittendButtonPush(event) {
    console.log('emittendButtonPushForm', event)
    if (event === 'genera') {
      if (this.formPopupStampaRegistri) {

        const dataSet = this.formPopupStampaRegistri

        if (dataSet['daData'] === null || dataSet['adata'] === null) {
          return alert('Selezionare un range di date', 'Attenzione');
        }

        const isDaDataValid = this.moment(dataSet['daData']).isValid();
        const isADataValid = this.moment(dataSet['aData']).isValid();
        if (!isDaDataValid || !isADataValid) {
          return alert('Le date inserite non sono valide', 'Attenzione');
        }
        const intervalloCorretto = this.moment(dataSet['daData']).isSameOrBefore(this.moment(dataSet['aData']));
        if (!intervalloCorretto) return alert('L\'intervallo di date non è corretto', 'Attenzione');

        if (dataSet['azione'] === null) {
          return alert('Selezionare un\'azione da eseguire', 'Attenzione');
        } else {

          if (dataSet['azione'] === 'stoccaggio') {
          }
          if (dataSet['azione'] === 'stampaEsportazione') {
            this.consolidaMovimenti(false)
          }
          if (dataSet['azione'] === 'esportazioneDefinitiva') {
            const primoMovimento = this.note.dataRegistrazionePrimoMovimentoDaConsolidare
            if (primoMovimento !== null && this.moment(primoMovimento).isBefore(this.moment(dataSet['daData']))) {
              return alert(`Hai uno o più movimenti da consolidare il ${new Date(primoMovimento).toLocaleDateString('it', { day: '2-digit', month: '2-digit', year: 'numeric' })}`, 'Attenzione')
            }
            this.consolidaMovimenti(true)
          }
        }

      }
    }
  }

  async reload() {
    await this.apiService.GetApi(`ModellodiStampa/GetByGUID/bb33baa2-fe89-467d-885d-fdcd3a547bfa`).then((data: IModelloStampa) => {
      this.modelloRegistroRentri = data || null
      console.log('modelloRegistroRentri', data)
    });
    await this.apiService.GetApi(`RenRegistrazioni/GetLatestProtocolAndDateFromRegistroWithNote?idRegistro=${this.reletedData['id']}`).then((data: nota) => {
      if (data) {
        this.note = data
      }
      console.log('note', data)
    }).catch((error) => {
      console.error('Errore durante le note', error)
    })
    if (this.formPopupStampaRegistri) {
      Object.keys(this.formPopupStampaRegistri).forEach((key) => {
        this.formPopupStampaRegistri[key] = null
        // if (key === 'daData') this.formPopupStampaRegistri[key] = this.note.dataRegistrazione
      })
    }
    this.cdr.detectChanges()
  }
  onValueChangedRadio(event) {
    console.log(event)
  }
  onClickInfo(event) {
    console.log(event)
    if (event && event.element) {
      let messagge = ''
      switch (event.element.id) {
        case 'infoNota':
          messagge = `<div style="max-width: 700px;">
          <p>
            Il numero di movimenti indicato corrisponde al numero di <b>MOVIMENTI DA ELABORARE</b>
             e non necessariamente corrisponde al numero di <b>REGISTRAZIONI RENTRI</b> che l'elaborazione andra' poi a generare.</br>
          </p>
          <p>
            Ogni <b>MOVIMENTO</b>, infatti, potrebbe generare anche piu' <b>REGISTRAZIONI RENTRI</b>.</br>
            Inoltre, per i centri di raccolta, non tutti i <b>MOVIMENTI</b> generano una <b>REGISTRAZIONE RENTRI</b>
          </p>
          </div>`
          alert(messagge, 'Attenzione')
          return;
        case 'stoccaggio':
          messagge = `<div style="max-width: 760px;">
          <p>
            Questa funzione va eseguita solo su richiesta degli organi di controllo (D. D. nr. 251 del 19.12.2023).</br>
            Viene elaborato un documento PDF che riporta per ogni CER la giacenza di questo registro alla data ${this.moment(this.note.dataRegistrazione).format('DD/MM/YYYY')}.</br>
            Se si vuole effettuare un calcolo ad una data maggiore occorre consolidare prima i movimenti fino a tale data.</br>
          </p>
          <p>
            <b>N.B.</b> Non occorre pertanto indicare data inizio e data fine per eseguire questa funzione
            I dati elaborati, se inviati al Rentri, assumono protocolli consecutivi al protocollo dell'ultimo movimento consolidato
          </p>
          </div>`
          alert(messagge, 'Attenzione')
          return;
        // case 'stampaEsportazione':
        //   messagge = `<div style="max-width: 630px;">
        //   La stampa definitiva ad uso interno del registro cronologico consente di visualizzare il documento in formato impaginato, così come verrà prodotto al termine del processo di elaborazione definitiva.</br>
        //   </br>
        //   Questa funzione è utile per effettuare un controllo preliminare del contenuto del registro, verificare la correttezza dei dati riportati e assicurarsi che la struttura del documento sia conforme ai requisiti previsti dalla normativa vigente.</br>
        //   </br>
        //   <b>N.B. </b>L’anteprima è accessibile in qualsiasi momento prima dell'esportazione definitiva del registro.
        //   </div>`
        //   alert(messagge, 'Attenzione')
        //   return;
        case 'esportazioneDefinitiva':
          messagge = `<div style="max-width: 600px;">
          <p> L’elaborazione definitiva del registro cronologico è l’attività propedeutica alla sottoscrizione digitale del registro e al suo invio al <b>Rentri</b> entro i temini di legge.</br></p>
          <p>Dopo l’elaborazione sarà quindi necessario avviare il processo definitivo di elaborazione nel pannello di controllo attivabile direttamente da questa stessa schermata a fine elaborazione oppure richiamando la specifica funzione dalla schermata principale di gestione dei registri cronologici!</p>
          </div>`
          alert(messagge, 'Attenzione')
          return;
        default:
          return
      }
    }
  }
  //! ----------------------------------------------------------------------------------------------------

  private async consolidaMovimenti(isDefinitivo: boolean) {
    const data = this.formPopupStampaRegistri;
    if (!data) return alert('Errore nei dati', 'Attenzione');
    const api = 'RenRegistrazioni/ConsolidaMovimenti'
    const query = `?idRegistro=${this.reletedData['id']}&dallaData=${data['daData']}&allaData=${data['aData']}&isDefinitivo=${isDefinitivo}`
    const messagge = isDefinitivo ? 'Errore durante il consolidamento' : 'Errore durante la generazione della stampa'
    if (!api || !query) return alert(messagge, 'Attenzione');
    try {
      this.spinner.show()
      this.apiService.GetApi(api + query).then((dati: []) => {
        if (isDefinitivo) {
          this.spinner.hide()
          if (!dati || dati.length === 0) return alert('Nessun dato da stampare', 'Attenzione')
          const msgConfirm = `<div style="max-width: 630px;">
          <p style="margin:0px;">Il flusso dati del registro cronologico è stato correttamente generato.</p> 
          <p>Sarà necessario procedere alla sottoscrizione digitale del flusso entro i termini previsti dall\'art.190 comma 1 - lettere a,b,c,d - del D.lgs152/2006.</p>
          <p style="margin:0px;">Si vuole accedere direttamente al panello di controllo ed eseguire questa operazione adesso ?</p>
          </div>`
          confirm(msgConfirm, 'Flusso dati XML generato').then((res) => {
            if (!res) {
              return this.reload()
            }
            Object.keys(this.formPopupStampaRegistri).forEach((key) => {
              this.formPopupStampaRegistri[key] = null
            })
            console.log(this.guid)
            this.componentService.destroyCurrentOpenPopUpByGuid(this.guid)
            setTimeout(() => {
              const guid = Math.random().toString().replace("0.", "");
              const instanceData = {
                reletedData: this.reletedData
              }
              this.componentService.setNewPopUp(guid, 'PopupEsportazioneRentriComponent', null, '900', null, instanceData, false, true, 'Esportazione Rentri/DH', 'top')
            }, 500)
          }).catch((error) => {
            console.error('Errore durante la conferma', error)
          })

        } else {
          this.spinner.hide()
          if (!dati || dati.length === 0) return alert('Nessun dato da stampare', 'Attenzione')
          this.apiService.PostApi(`RenRegistrazioni/ConvertRenRegistrazioniListIntoMovimentiPerStampa?idRegistro=${this.reletedData['id']}`, dati).then((datiPdf: []) => {
            this.spinner.hide()
            if (!datiPdf || datiPdf.length === 0) return alert('Nessun dato da stampare', 'Attenzione')
            if (!this.modelloRegistroRentri) return alert('Modello di stampa non presente', 'Attenzione')
            this.modelliStampaService.generaPDF(datiPdf, this.modelloRegistroRentri.id, 'preview').then((id) => {
              this.componentService.outputComponent.subscribe(currentOutput => {
                if (currentOutput.guid == id) {
                  console.log('currentOutput--->', currentOutput)
                  if (currentOutput.name == "close") {
                    this.componentService.destroyCurrentOpenPopUpByGuid(id);
                    this.componentService.destroyOutputComponent();
                  }
                }
              })
            }).catch((error) => {
              throw new Error('Errore durante la generazione pdf: ' + error)
            })
          }).catch((error) => {
            throw new Error('Errore durante la conversione: ' + error)
          })

        }

      }).catch((error) => {
        throw new Error('Errore durante consolidaMovimenti: ' + error);
      })
    } catch (error) {
      this.spinner.hide()
      console.log(error)
      alert(messagge, 'Attenzione')
    }
  }
}